import { Card as AntdCard } from "antd";
import React from "react";
import "../styles/components/Card.css";

interface Props {
  id?: string;
  className?: string;
  bordered?: boolean;
  children?: React.ReactNode;
  header?: React.ReactNode;
  extra?: React.ReactNode;
  style?: React.CSSProperties;
}

export default class Card extends React.Component<
  Props,
  Record<string, unknown>
> {
  render(): JSX.Element | null {
    const { children, bordered, style, id, className, header, extra } =
      this.props;

    return (
      <AntdCard
        id={id}
        bordered={bordered}
        className={`tile-card data-card ${className ?? ""}`}
        style={{
          ...style,
        }}
        title={header}
        extra={extra}
      >
        {children}
      </AntdCard>
    );
  }
}
